import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';

interface Props {
  children?: React.ReactNode;
  description?: string;
  title: string;
  titleCount?: number;
}

const PageSectionHeader = ({
  children,
  description,
  title,
  titleCount
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="header">
      <div className="header-inner">
        <div className="title">
          <div className="title-content">
            <div className="title-text">
              <div className="title-text-content">{title}</div>

              {titleCount !== undefined ? (
                <div className="title-count">{`(${titleCount})`}</div>
              ) : null}
            </div>

            {description ? (
              <div className="description">{description}</div>
            ) : null}
          </div>
        </div>

        {children ? <div className="header-content">{children}</div> : null}
      </div>

      <style jsx>{`
        .header {
          margin-bottom: 20px;
          padding: 5px;
        }
        .title {
          align-items: flex-start;
          display: flex;
          flex-grow: 1;
          min-width: 0;
        }
        .title-content {
          display: inline-flex;
          flex-direction: column;
        }
        .title-text {
          color: ${theme.pageTextColor || theme.textColor};
          font-size: 1.6rem;
          font-weight: 700;
        }
        .title-text-content {
          display: inline-block;
          margin-right: 5px;
        }
        .title-count {
          display: inline-block;
        }
        .description {
          color: ${theme.pageTextColorLighter || theme.textColorLighter};
          font-size: 1.5rem;
          font-weight: 400;
          line-height: 1.4;
          margin-top: 3px;
        }
        @media (max-width: ${breakpoints.small - 1}px) {
          .header-content {
            margin-top: 15px;
          }
        }
        @media (min-width: ${breakpoints.small}px) {
          .header-inner {
            align-items: center;
            display: flex;
          }
        }
      `}</style>
    </div>
  );
};

export default PageSectionHeader;
